import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const MainCarousel = (props) => {
	const { children, swipeable = true, draggable = false, showDots = false, responsive, ssr = true, infinite = true, autoPlaySpeed, keyBoardControl = true, partialVisible = true, removeArrowOnDeviceType, additionalTransfrom, itemClass, minimumTouchDrag = 50, handleRightClick = () => { }, handleLeftClick = () => { } } = props;

	const CustomRightArrow = ({ onClick, ...rest }) => {
		// const { onMove, state: { currentSlide, deviceType } } = rest;
		// onMove means if dragging or swiping in progress.
		return <button className='react-multiple-carousel__arrow react-multiple-carousel__arrow--right' onClick={() => {
			handleRightClick();
			onClick();
		}} />
	}

	const CustomLeftArrow = ({ onClick, ...rest }) => {
		// const { onMove, state: { currentSlide, deviceType } } = rest;
		// onMove means if dragging or swiping in progress.
		return <button className='react-multiple-carousel__arrow react-multiple-carousel__arrow--left' onClick={() => {
			handleLeftClick()
			onClick()
		}} />
	}

	return (
		<Carousel
			swipeable={swipeable}
			draggable={draggable}
			showDots={showDots}
			responsive={responsive}
			ssr={ssr} // means to render carousel on server-side.
			infinite={infinite}
			autoPlaySpeed={autoPlaySpeed}
			keyBoardControl={keyBoardControl}
			partialVisible={partialVisible}
			removeArrowOnDeviceType={removeArrowOnDeviceType}
			additionalTransfrom={additionalTransfrom}
			itemClass={itemClass}
			minimumTouchDrag={minimumTouchDrag}
			customRightArrow={<CustomRightArrow />}
			customLeftArrow={<CustomLeftArrow />}
		>
			{children}
		</Carousel>
	)
}

export default MainCarousel;